import { TSetClientPasswordParams } from 'types/services';
import { m8API } from 'services/production/m8';

export const setClientPassword = async (params: TSetClientPasswordParams) => {
  const { emailToken, password } = params;

  await m8API.auth.setUserPassword({ token: emailToken, password });
};
